import { IMG_4VCj3kLYoNj48WBdzQapRw } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabWater() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'Siren',
      text: t('detail.water-alert')
    },
    {
      icon: 'PhoneRinging',
      text: t('detail.sensor-app-notification')
    },
    {
      icon: 'Phone',
      text: t('detail.sensor-phone-call')
    },
    {
      icon: 'Clock',
      text: t('detail.sensor-pause')
    }
  ] as const
  const disclaimers = [t('disclaimer.sensor-monitoring-plan')] as const
  return (
    <AlarmMomentsTab
      image={IMG_4VCj3kLYoNj48WBdzQapRw}
      details={details}
      disclaimers={disclaimers}
    />
  )
}
